<template>
  <div class="main-block">
    <div class="details-component__header">
        <span>
          <h1>{{ $t('payment.list') }}</h1>
        </span>
      <div class="details-component__header_right d-flex">
        <RegisterCardButton
          v-if="cards.length > 0"
          iconClass="icon-add-card-s"
        />
        <div v-on:click="toggleSection" :class="!showSection ? toggleIconDown : toggleIconUp">&nbsp;</div>
      </div>
    </div>
    <div v-show="showSection">
      <div v-if="!this.inProgress">
        <Cards v-if="cards.length > 0" :cards="cards" />
        <div v-else class="d-flex">
          <div class="add-new-card-message">
            <RegisterCardButton
              iconClass="icon-add-card-m"
              :iconText="$t('payment.add_new')"
            />
          </div>
        </div>
      </div>
      <div v-else class="loader-bubbles"></div>
    </div>
  </div>

</template>

<script>

import {mapGetters} from "vuex";
import RegisterCardButton from "../ui/RegisterCardButton";
import Cards from "../ui/Cards";

export default {
  components: {
    Cards,
    RegisterCardButton
  },
  data() {
    return {
      showSection: true,
      toggleIconDown: 'icon icon-bl-arrow-down',
      toggleIconUp: 'icon icon-bl-arrow-up'
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user/user',
      cards: 'payment/cards/cardList',
      inProgress: 'payment/cards/inProgress',
      showConfirmationModal: 'payment/cards/showConfirmationModal'
    })
  },
  methods: {
    toggleSection() {
      this.showSection = !this.showSection
    }
  },
  mounted() {
    if (!this.inProgress && this.user.paymentModuleEnabled) {
      this.$store.dispatch('payment/cards/fetchUserCardList')
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../../../styles/spinner';
@import '~styles/app.scss';
@import '../assets/styles/payment';

</style>



// WEBPACK FOOTER //
// src/components/payment/features/CardList.vue